import { render } from "./Sidebar-menu-akahon.vue?vue&type=template&id=8455bf50"
import script from "./Sidebar-menu-akahon.vue?vue&type=script&lang=js"
export * from "./Sidebar-menu-akahon.vue?vue&type=script&lang=js"

import "./Sidebar-menu-akahon.vue?vue&type=style&index=0&id=8455bf50&lang=css"

import exportComponent from "C:\\bipom\\VSVN\\dude\\Web\\SmartLamp\\2.03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__